import customerApi from "../api/customer";
import categoryApi from "~/api/category";
import user from "../api/user";
import hasAttachableApi from "../api/has_attachable";

export default {
  getInstance({ state, commit }) {
    hasAttachableApi.getByIdAndClassOrType(
      state.instance?.id,
      state.instance?.type,
      state.instance?.class,
    ).then((response) => {
      commit("SET_PAGE_INSTANCE", response.data);
    });
  },
  getMe({ commit, state }) {
    if (state.meCalled) return;
    // eslint-disable-next-line consistent-return
    return user.getMe().then((response) => {
      commit("SET_ME_CALLED", true);
      commit("SET_ME", response.data);
    }).catch(() => {
      commit("SET_ME_CALLED", false);
    });
  },
  async getCustomer(context, customerId) {
    if (!context.getters.hasCustomerById(customerId)) {
      await customerApi.find(customerId)
        .then((response) => {
          context.commit("SET_CUSTOMER", { customerId, customer: response.data });
        });
    }
  },
  async fetchCustomer(context, customerId) {
    if (!context.getters.hasCustomerById(customerId)) {
      await customerApi.find(customerId)
        .then((response) => {
          context.commit("SET_CUSTOMER", { customerId, customer: response.data });
        });
    }
  },

  getCategoryName({ state, commit }) {
    if (!state.category_id) return;
    categoryApi.find(state.category_id).then((response) => {
      commit("SET_CATEGORY", response.data);
    });
  },
  getExtensions({ state, commit }) {
    if (!state.me.id && state.extensionsCalled) return;
    commit("SET_EXTENSIONS_CALLED", true);
    user.getUserExtensions(state.me.id).then((response) => {
      commit("SET_EXTENSIONS", response.data);
      commit("SET_ACTIVE_EXTENSION", response.data[0]);
    }).catch(() => {
      commit("SET_EXTENSIONS_CALLED", false);
    });
  },
};
